import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { grey } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/FavoriteTwoTone';
import ShareIcon from '@material-ui/icons/ShareTwoTone';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/EditTwoTone';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LooksOneTwoToneIcon from '@material-ui/icons/LooksOneTwoTone';
import LooksTwoTwoToneIcon from '@material-ui/icons/LooksTwoTwoTone';
import Looks3TwoToneIcon from '@material-ui/icons/Looks3TwoTone';
import Looks4TwoTone from '@material-ui/icons/Looks4TwoTone';
import Looks5TwoTone from '@material-ui/icons/Looks5TwoTone';
import Looks6TwoTone from '@material-ui/icons/Looks6TwoTone';
import Looks7TwoTone from '@material-ui/icons/Filter7TwoTone';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import VerbTypesIcon from './VerbTypesIcon';
import VerbRegularIcon from './VerbRegularIcon';
import VerbFrequencyIcon from './VerbFrequencyIcon';
import SettingsMenu from './SettingsMenu';
import SettingsMenuDialog from './SettingsMenuDialog';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import SettingsDialog from './SettingsDialog';

let booked = false;

const useStyles = (theme) => ({
  card: {
    //   maxWidth: 385,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  booked: {
    color: 'orange',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: grey[600],
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
});

export class WordCard extends Component {
  state = {
    selected: 0,
    expanded: false,
  };

  // let selected=0;

  nextClick = () => {
    this.setState({
      selected: 1,
    });
  };

  handleExpandClick = () => {
    let tempexopanded = !this.state.expanded;
    this.setState({
      expanded: tempexopanded,
    });
  };

  handleBookmarkClick = () => {
    this.props.handleBookmark(!booked);
  };

  handleSettingsChanged = (settings) => {
    //alert("ds");
    this.props.handleSettingsChanged(settings);
  };
  handleTextSpeakClick = (text, voice) => {
    document.getElementById('speakdiv').innerHTML = text;
    if (this.props.verbs[this.props.selected].set == 'French') {
      document.getElementById('voicediv').innerHTML = 'FrenchVoice';
    }
    if (this.props.verbs[this.props.selected].set == 'Italian') {
      document.getElementById('voicediv').innerHTML = 'ItalianVoice';
    } else {
      document.getElementById('voicediv').innerHTML = 'SpanishVoice';
    }
    document.getElementById('speakdiv').click();
  };

  ClickEdit() {
    this.props.ClickEdit();
  }
  ClickLevel() {
    this.props.ClickLevel();
  }
  ClickVerbType() {}

  render() {
    const { classes } = this.props;
    ///  const classes = useStyles();
    //   const [expanded, setExpanded] = React.useState(false);

    let level = (
      <IconButton
        onClick={() => this.ClickLevel()}
        aria-label="Add to favorites"
      >
        <LooksOneTwoToneIcon />
      </IconButton>
    );
    let avatar_icon = (
      <Avatar aria-label="Recipe" className={classes.avatar}>
        R
      </Avatar>
    );
    let verb_type = (
      <IconButton
        size="small"
        onClick={() => this.ClickVerbType()}
        aria-label="Add to favorites"
      >
        <Avatar
          variant="square"
          aria-label="Recipe"
          className={(classes.avatar, classes.small)}
        >
          UR
        </Avatar>
      </IconButton>
    );

    let bookmarked = (
      <IconButton
        onClick={this.handleBookmarkClick}
        aria-label="Add to favorites"
      >
        <FavoriteIcon />
      </IconButton>
    );
    if (
      this.props.mounted &&
      this.props.verbs != undefined &&
      this.props.verbs.length > 0
    ) {
      if (this.props.verbs[this.props.selected].bookmarked != undefined) {
        if (this.props.verbs[this.props.selected].bookmarked) {
          booked = true;
          bookmarked = (
            <IconButton
              className={classes.booked}
              onClick={this.handleBookmarkClick}
              aria-label="Add to favorites"
              color="primary"
            >
              <FavoriteIcon />
            </IconButton>
          );
        } else {
          booked = false;
        }
      }

      if (this.props.verbs[this.props.selected].level != undefined) {
        if (this.props.verbs[this.props.selected].level == 2) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <LooksTwoTwoToneIcon />
            </IconButton>
          );
        } else if (this.props.verbs[this.props.selected].level == 3) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks3TwoToneIcon />
            </IconButton>
          );
        } else if (this.props.verbs[this.props.selected].level == 4) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks4TwoTone />
            </IconButton>
          );
        } else if (this.props.verbs[this.props.selected].level == 5) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks5TwoTone />
            </IconButton>
          );
        } else if (this.props.verbs[this.props.selected].level == 6) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks6TwoTone />
            </IconButton>
          );
        } else if (this.props.verbs[this.props.selected].level == 7) {
          level = (
            <IconButton
              onClick={() => this.ClickLevel()}
              className={classes.booked}
              aria-label="Add to favorites"
            >
              <Looks7TwoTone />
            </IconButton>
          );
        }
      }

      let set = this.props.verbs[this.props.selected].set;
      if (set != undefined) {
        if (set == 'French') {
          avatar_icon = (
            <Avatar aria-label="French" className={classes.avatar}>
              FR
            </Avatar>
          );
        } else if (set == 'Spanish') {
          avatar_icon = (
            <Avatar aria-label="French" className={classes.avatar}>
              ES
            </Avatar>
          );
        } else if (set == 'Italian') {
          avatar_icon = (
            <Avatar aria-label="French" className={classes.avatar}>
              IT
            </Avatar>
          );
        }
        else if (set == 'German') {
          avatar_icon = (
            <Avatar aria-label="French" className={classes.avatar}>
              DE
            </Avatar>
          );
        }
      }

      let type = this.props.verbs[this.props.selected].verb_type;
      if (type != undefined) {
        if (type == 'Irregular') {
          verb_type = (
            <Avatar
              variant="square"
              aria-label="Irregular"
              className={(classes.avatar, classes.small)}
            >
              Ir
            </Avatar>
          );
        } else if (type == 'ER') {
          verb_type = (
            <Avatar
              variant="square"
              aria-label="ER"
              className={(classes.avatar, classes.small)}
            >
              ER
            </Avatar>
          );
        } else if (type == 'IR') {
          verb_type = (
            <Avatar
              variant="square"
              aria-label="IR"
              className={(classes.avatar, classes.small)}
            >
              IR
            </Avatar>
          );
        }
      }
    }
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////
    ////////////////RENDER
    return (
      <Paper>
        {this.props.mounted &&
        this.props.verbs != undefined &&
        this.props.verbs.length > 0 ? (
          <main className="card full-height white">
            <section className="card__header">
              <CardHeader
                avatar={avatar_icon}
                action={
                  <div className="flex-row">
                    <SettingsDialog
                      settingSpeak={this.props.settingSpeak}
                      handleSettingsChanged={this.handleSettingsChanged}
                    ></SettingsDialog>
                    <SettingsMenuDialog
                      ClickEdit={this.props.ClickEdit}
                      ClickDate={this.props.ClickDate}
                    ></SettingsMenuDialog>
                  </div>
                }
                title={
                  this.props.verbs[this.props.selected].Language1 +
                  ' , ' +
                  this.props.verbs[this.props.selected].set
                }
                subheader={
                  <div>
                    {this.props.verbs[this.props.selected].Language2} <br></br>{' '}
                    {this.props.verbs[this.props.selected].PresentParticiple +
                      ' ' +
                      this.props.verbs[this.props.selected].PastParticiple}
                  </div>
                }
              />
            </section>
            <section className="card__body">
              <CardContent>
                <div>
                  {/* {console.log(this.props)} */}
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Present &&
                        this.props.verbs[this.props.selected].Present.map(
                          (p) => (
                            <Typography
                              onClick={() => this.handleTextSpeakClick(p)}
                              variant="body2"
                              color="textSecondary"
                              component="p"
                            >
                              {p}
                            </Typography>
                          )
                        )}
                    </Grid>

                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Past &&
                        this.props.verbs[this.props.selected].Past.map((p) => (
                          <Typography
                            onClick={() => this.handleTextSpeakClick(p)}
                            variant="body2"
                            color="textSecondary"
                            component="p"
                          >
                            {p}
                          </Typography>
                        ))}
                    </Grid>
                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Past1 &&
                        this.props.verbs[this.props.selected].Past1.map((p) => (
                          <Typography
                            onClick={() => this.handleTextSpeakClick(p)}
                            variant="body2"
                            color="textSecondary"
                            component="p"
                          >
                            {p}
                          </Typography>
                        ))}
                    </Grid>
                  </Grid>
                  <br></br>
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Future &&
                        this.props.verbs[this.props.selected].Future.map(
                          (p) => (
                            <Typography
                              onClick={() => this.handleTextSpeakClick(p)}
                              variant="body2"
                              color="textSecondary"
                              component="p"
                            >
                              {p}
                            </Typography>
                          )
                        )}
                    </Grid>

                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Conditional &&
                        this.props.verbs[this.props.selected].Conditional.map(
                          (p) => (
                            <Typography
                              onClick={() => this.handleTextSpeakClick(p)}
                              variant="body2"
                              color="textSecondary"
                              component="p"
                            >
                              {p}
                            </Typography>
                          )
                        )}
                    </Grid>

                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected]
                        .Present_Subjunctive &&
                        this.props.verbs[
                          this.props.selected
                        ].Present_Subjunctive.map((p) => (
                          <Typography
                            onClick={() => this.handleTextSpeakClick(p)}
                            variant="body2"
                            color="textSecondary"
                            component="p"
                          >
                            {p}
                          </Typography>
                        ))}
                    </Grid>
                  </Grid>
                  <br></br>
                  <Grid container spacing={1}>
                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Imperativ &&
                        this.props.verbs[this.props.selected].Imperativ.map(
                          (p) => (
                            <Typography
                              onClick={() => this.handleTextSpeakClick(p)}
                              variant="body2"
                              color="textSecondary"
                              component="p"
                            >
                              {p}
                            </Typography>
                          )
                        )}
                    </Grid>

                    <Grid item xs={4}>
                      {this.props.verbs[this.props.selected].Imperativ1 &&
                        this.props.verbs[this.props.selected].Imperativ1.map(
                          (p) => (
                            <Typography
                              onClick={() => this.handleTextSpeakClick(p)}
                              variant="body2"
                              color="textSecondary"
                              component="p"
                            >
                              {p}
                            </Typography>
                          )
                        )}
                    </Grid>
                  </Grid>
                </div>
              </CardContent>
            </section>
            {this.props.verbs[this.props.selected].Description1 ? (
              <div className="black-row">
                {this.props.verbs[this.props.selected].Description1}
              </div>
            ) : (
              <div></div>
            )}

            <section className="card__footer">
              {bookmarked}
              {level}
              <VerbTypesIcon
                UpdateField={this.props.UpdateField}
                verb_type={this.props.verbs[this.props.selected].verb_type}
              ></VerbTypesIcon>
              <VerbRegularIcon
                UpdateField={this.props.UpdateField}
                regular={this.props.verbs[this.props.selected].regular}
              ></VerbRegularIcon>
              <VerbFrequencyIcon
                UpdateField={this.props.UpdateField}
                frequency={this.props.verbs[this.props.selected].frequency}
              ></VerbFrequencyIcon>

              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: this.state.expanded,
                })}
                onClick={this.handleExpandClick}
                aria-expanded={this.state.expanded}
                aria-label="Show more"
              >
                <ExpandMoreIcon />
              </IconButton>
            </section>
            {/* <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
              <CardContent>
                <Typography
                  onClick={() =>
                    this.handleTextSpeakClick(
                      this.props.verbs[this.props.selected].Description1
                    )
                  }
                  variant="body2"
                  color="textSecondary"
                  component="p"
                >
                  {this.props.verbs[this.props.selected].Description1}
                </Typography>
              </CardContent>
            </Collapse> */}
          </main>
        ) : (
          <div></div>
        )}
      </Paper>
    );
  }
}

WordCard.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default WordCard;
export default withStyles(useStyles)(WordCard);
